import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Input,
  ModalFooter,
  Button,
} from '@chakra-ui/react';
import {
  AppConfigs,
  PrimaryStorage,
  UserMetaData,
} from '../../../core/redux/auth/authTypes';
import { useEffect, useRef } from 'react';
import { useFormik } from 'formik';
import { PasswordField } from '../login/PasswordField';
import { useTranslation } from 'react-i18next';
import { validateUserPassKey } from '../../../core/database/user/multiUserStorage';
import { ResultWithOptionalError } from '../../../core/types/generic/results';

export enum PassKeyValidationType {
  Login = 'login',
  PasswordVerification = 'passwordVerification',
}

interface PassKeyValidationModalProps {
  userMetaData: UserMetaData;
  appConfigs?: AppConfigs;
  validationType: PassKeyValidationType;
  onClose?: () => void;
  onLogout?: () => void
  onPassKeyValidation: (privateKey: CryptoKey) => void;
}

interface FormikState {
  passKey: string;
}

const PassKeyValidationModal: React.FC<PassKeyValidationModalProps> = ({
  userMetaData,
  appConfigs,
  validationType,
  onClose = () => {},
  onLogout,
  onPassKeyValidation,
}) => {
  const { t } = useTranslation();

  const startValidatePassKey = async (state: FormikState) => {
    const result: ResultWithOptionalError<CryptoKey> =
      await validateUserPassKey(userMetaData.id, state.passKey);
    if (result.error) formik.errors.passKey = result.error.message;
    else if (result.data) {
      onPassKeyValidation(result.data);
      onClose();
    }
  };
  const formik = useFormik<FormikState>({
    initialValues: {
      passKey: '',
    },
    onSubmit: startValidatePassKey,
    validateOnChange: false,
    validateOnBlur: false,
  });

  const passwordRef = useRef<HTMLInputElement>(null);

  const validationButtonTitle =
    appConfigs?.localBackups ||
    appConfigs?.primaryStorage === PrimaryStorage.FileSystem
      ? t('permission.passKey.validate-permisison')
      : t('permission.passKey.validate');

  const closeButtonTitle =
    validationType === PassKeyValidationType.Login
      ? t('permission.passKey.logout')
      : t('permission.passKey.close');

  return (
    <Modal
      initialFocusRef={passwordRef}
      isOpen={true}
      onClose={onClose}
      isCentered
      //   motionPreset="slideInBottom"
    >
      <ModalOverlay />
      <form onSubmit={formik.handleSubmit}>
        <ModalContent>
          <ModalHeader>{userMetaData.fullname}</ModalHeader>
          {validationType !== PassKeyValidationType.Login && (
            <ModalCloseButton />
          )}
          <ModalBody pb={6}>
            <PasswordField
              title={t('permission.passKey.passTitle')}
              value={formik.values.passKey}
              onChange={formik.handleChange}
              name="passKey"
              error={formik.errors.passKey}
              ref={passwordRef}
            />
          </ModalBody>

          <ModalFooter>
            <Button mr={3} onClick={onLogout ?? onClose}>
              {closeButtonTitle}
            </Button>
            <Button colorScheme="blue" type="submit">
              {validationButtonTitle}
            </Button>
          </ModalFooter>
        </ModalContent>
      </form>
    </Modal>
  );
};

export default PassKeyValidationModal;
